import * as yup from 'yup'

export const schema = yup.object().shape({
  name: yup.string().required(),
  tradeName: yup.string().required(),
  cnpj: yup.string().min(18, 'O CNPJ deve conter 14 caracteres'),
})

export default schema
